export default __webpack_public_path__ + "static/media/Genitalia.5916fa55.png";